import { faChevronRight, faPersonSkiing } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../shared/components/button/Button';
import useKeyboardAction from '../../shared/hooks/useKeyboardAction.ts';
import ActivityTracker from './ActivityTracker';

function MovementCover(props) {
  const { closeTrackers } = props;
  const { t } = useTranslation();

  const [areaPicker, setAreaPicker] = useState(true);
  const [openActivity, setOpenActivity] = useState(false);

  const handleActivity = () => {
    const main = document.getElementById('snm-main');
    main?.classList.remove('slide-in');
    setTimeout(() => {
      setAreaPicker(false);
      setOpenActivity(true);
    }, 500);
  };

  useKeyboardAction(() => {
    closeTrackers();
  }, 'Escape');

  useEffect(() => {
    if (openActivity) {
      const activity = document.getElementById('snm-activity');
      setTimeout(() => {
        activity?.classList.add('slide-in');
      }, 300);
    }
  }, [openActivity]);

  useEffect(() => {
    if (areaPicker) {
      const main = document.getElementById('snm-main');
      setTimeout(() => {
        main?.classList.add('slide-in');
      }, 300);
    }
  }, [areaPicker]);

  const handleBackToMain = () => {
    if (openActivity) {
      const activity = document.getElementById('snm-activity');
      activity?.classList.remove('slide-in');
      setTimeout(() => {
        setOpenActivity(false);
        setAreaPicker(true);
      }, 500);
    }
  };

  return (
    <>
      {areaPicker && (
        <div id="snm-main" className="tracker-container">
          <div className="ind-tracker mood">
            <h2 className="title">{t('T134')}</h2>
            <button
              className="mood-area"
              onClick={handleActivity}
              type="button"
              aria-label={t('T346')}
            >
              <div>
                <FontAwesomeIcon icon={faPersonSkiing} className="mood-icon" /> {t('T346')}{' '}
              </div>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>
          <div className="buttons mood">
            <Button onClick={props.closeTrackers} variant="secondary" color="dark">
              {t('T015')}
            </Button>
          </div>
        </div>
      )}{' '}
      {openActivity && (
        <ActivityTracker handleBackToMain={handleBackToMain} closeTrackers={props.closeTrackers} />
      )}
    </>
  );
}
export default MovementCover;
